<div class="container-state" [ngClass]="getBackgroundColor()"
     [class.warning]="state === 'PENDING' || state === 'AWAITING_SEND'"
     [class.success]="state === 'SUCCESS'"
     [class.error]="state === 'ERROR'">
  <ng-container *ngIf="state === 'PENDING'">
    En attente d'installation
  </ng-container>
  <ng-container *ngIf="state === 'AWAITING_SEND'">
    En attente d'envoi
  </ng-container>
  <ng-container *ngIf="state === 'SUCCESS'">
    Installation terminée
  </ng-container>
  <ng-container *ngIf="state === 'ERROR'">
    Problème d'installation
  </ng-container>
</div>
